<template>
	<div class="main-blog-section relative flex flex-col px-6 pt-10">
		<LandingShape9 class="absolute end-[0px] top-[400px] h-auto w-[158px] text-[#F8EDE2] rtl:-scale-x-100" />
		<LandingShape1 class="absolute start-[40px] top-[121px] h-auto w-[78px] md:start-[140px]" />
		<LandingShape4 class="absolute start-[86px] top-[42px] h-auto w-[64px] text-[#EA6939] max-md:hidden" />
		<LandingShape6 class="absolute end-[52px] top-[81px] h-auto w-[36px]" />
		<LandingShape7 class="absolute end-[43px] top-[92px] h-auto w-[36px] text-[#f58931]" />
		<LandingShape7 class="absolute start-[33px] top-[248px] h-auto w-[20px] text-[#387fc4]" />
		<LandingShape2 class="absolute start-[35px] top-[527px] h-auto w-[66px] rotate-90 text-[#F8BF08]" />
		<LandingShape2 class="absolute end-[23px] top-[400px] h-auto w-[66px] rotate-[240deg] text-[#F8BF08]" />
		<div class="relative flex w-full max-w-screen-xl flex-col self-center">
			<span class="text-center text-3xl font-black leading-normal text-[#382C5C] md:text-4xl">
				{{ $t("news_and_resources") }}
			</span>
			<div class="-mx-6 flex flex-col overflow-hidden px-6 pb-28 pt-20">
				<Swiper
					v-if="articles?.length"
					class="w-full !overflow-visible"
					:pagination="{
						enabled: true
					}"
					:modules="[Pagination]"
					:breakpoints="{
						0: { slidesPerGroup: 1, slidesPerView: 1, spaceBetween: 24 },
						640: { slidesPerGroup: 2, slidesPerView: 2, spaceBetween: 24 },
						768: { slidesPerGroup: 2, slidesPerView: 2, spaceBetween: 24 },
						1024: { slidesPerGroup: 3, slidesPerView: 3, spaceBetween: 24 },
						1280: { slidesPerGroup: 3, slidesPerView: 3, spaceBetween: 32 }
					}"
				>
					<SwiperSlide v-for="article in articles" :key="article.id" class="!flex !h-auto flex-grow flex-col">
						<ArticleCard :article="article" class="flex-grow" />
					</SwiperSlide>
				</Swiper>
				<span
					v-else
					class="text-neutral-300 bg-slate-50 border-slate-200 pointer-events-none select-none rounded-xl border px-6 py-24 text-center text-4xl font-black shadow-inner"
				>
					{{ $t("nothing_found") }}
				</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { Pagination } from "swiper/modules"
import type { Post } from "~/models/post"

import LandingShape1 from "~/assets/svg/landing_shape_1.svg"
import LandingShape2 from "~/assets/svg/landing_shape_2.svg"
import LandingShape4 from "~/assets/svg/landing_shape_4.svg"
import LandingShape6 from "~/assets/svg/landing_shape_6.svg"
import LandingShape7 from "~/assets/svg/landing_shape_7.svg"
import LandingShape9 from "~/assets/svg/landing_shape_9.svg"

defineProps<{
	articles?: Post[]
}>()
</script>

<style>
.main-blog-section .swiper-pagination-horizontal {
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: -72px;
}
.main-blog-section .swiper-pagination-bullet {
	@apply bg-[#babdb8] opacity-100;
}
.main-blog-section .swiper-pagination-bullet-active {
	@apply bg-primary opacity-100;
}
</style>
